// client/src/components/marketer/result/modals/RejectModal.js
import React, { useState } from 'react';
import '../../../../styles/marketer/modals/ResultRejectModals.css';

export default function RejectModal({ open, onClose, influencerName, onConfirm }) {
  const [reason, setReason] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    if (!reason.trim()) {
      alert('거절 사유를 입력해주세요.');
      return;
    }
    
    if (!isConfirmed) {
      alert('확인 체크박스를 선택해주세요.');
      return;
    }

    setIsConfirming(true);
    try {
      await onConfirm(reason);
    } finally {
      setIsConfirming(false);
    }
  };

  const remainingChars = 2000 - reason.length;

  return (
    <div className="result-reject-modal mbm-overlay">
      <div className="result-reject-modal__content mbm" onClick={(e) => e.stopPropagation()}>
        {/* 닫기 버튼 */}
        <button onClick={onClose} className="result-reject-modal__close mbm-close">×</button>
        
        {/* 헤더 */}
        <div className="result-reject-modal__icon-container">
          <div className="result-reject-modal__icon">✕</div>
        </div>
        <h2 className="result-reject-modal__title mbm-title">결과물 거절</h2>
        <div className="result-reject-modal__subtitle">
          <strong>{influencerName}</strong>님의 결과물을 거절하시겠습니까?
        </div>

        {/* 거절 사유 입력 */}
        <div className="result-reject-modal__section">
          <div className="result-reject-modal__section-title">
            거절 사유 <span className="result-reject-modal__required">*</span>
          </div>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="거절 사유를 상세히 작성해주세요. (최대 2000자)"
            maxLength={2000}
            className="result-reject-modal__textarea"
          />
          <div className="result-reject-modal__char-count">
            {remainingChars.toLocaleString()}자 남음
          </div>
        </div>

        {/* 안내 메시지 */}
        <div className="result-reject-modal__warning-box">
          <div className="result-reject-modal__warning-title">⚠️ 거절 시 처리되는 내용</div>
          <ul className="result-reject-modal__warning-list">
            <li>결과물이 <strong>거절 상태</strong>로 변경됩니다.</li>
            <li>셀프애드 관리자 팀이 <strong>검토</strong>를 진행합니다.</li>
            <li>관리자 검토 후 <strong>최종 승인</strong> 또는 <strong>계약 취소</strong> 처리됩니다.</li>
            <li>최종 승인 시 인플루언서에게 보상 포인트가 지급됩니다.</li>
            <li>계약 취소 시 인플루언서는 보상을 받지 못합니다.</li>
          </ul>
        </div>

        {/* 확인 체크박스 */}
        <div className="result-reject-modal__checkbox-container">
          <label className="result-reject-modal__checkbox-label">
            <input
              type="checkbox"
              checked={isConfirmed}
              onChange={(e) => setIsConfirmed(e.target.checked)}
              className="result-reject-modal__checkbox"
            />
            위 내용을 확인했으며, 거절 사유가 정확함을 확인합니다.
          </label>
        </div>

        {/* 버튼 */}
        <div className="result-reject-modal__button-group mbm-foot">
          <button
            onClick={onClose}
            disabled={isConfirming}
            className={`result-reject-modal__button result-reject-modal__button--cancel mb-btn mb-btn-secondary ${
              isConfirming ? 'result-reject-modal__button--disabled' : ''
            }`}
          >
            취소
          </button>
          <button
            onClick={handleConfirm}
            disabled={isConfirming || !reason.trim() || !isConfirmed}
            className={`result-reject-modal__button result-reject-modal__button--reject mb-btn mb-btn-danger-solid ${
              isConfirming || !reason.trim() || !isConfirmed ? 'result-reject-modal__button--disabled' : ''
            }`}
          >
            {isConfirming ? '처리 중...' : '거절하기'}
          </button>
        </div>
      </div>
    </div>
  );
}
